/**
 * Shell de modal sobre o detalhe V2 (histórico, logs, sugestão).
 */

import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import './OrderDetailsV2MenuModal.css';

const CLOSE_MS = 280;

export function OrderDetailsV2MenuModal({
  open,
  onClose,
  title,
  icon = null,
  orderId,
  titleId,
  titleSuffix = null,
  closeAriaLabel = 'Fechar',
  panelClassName = '',
  bodyClassName = '',
  children,
}) {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) setMounted(true);
  }, [open]);

  useEffect(() => {
    if (!open && mounted) {
      const t = setTimeout(() => setMounted(false), CLOSE_MS);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [open, mounted]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!mounted) return null;

  const panelClass = [
    'odv2-menu-modal-panel',
    open ? 'odv2-menu-modal-panel--open' : '',
    panelClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const bodyClass = ['odv2-menu-modal-body', bodyClassName].filter(Boolean).join(' ');

  return (
    <div
      className={`odv2-menu-modal-overlay${open ? ' odv2-menu-modal-overlay--open' : ''}`}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={panelClass}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="odv2-menu-modal-header">
          <h2 id={titleId} className="odv2-menu-modal-title">
            {icon}
            {title}
            {titleSuffix}
            {orderId ? <span className="odv2-menu-modal-os">OS {orderId}</span> : null}
          </h2>
          <button
            type="button"
            className="odv2-menu-modal-close"
            aria-label={closeAriaLabel}
            onClick={onClose}
          >
            <X size={18} strokeWidth={2} aria-hidden />
          </button>
        </header>
        <div className={bodyClass}>{children}</div>
      </div>
    </div>
  );
}
